import { render, staticRenderFns } from "./ServiceProviderConfigurationHeader.vue?vue&type=template&id=e1023e64&scoped=true"
import script from "./ServiceProviderConfigurationHeader.vue?vue&type=script&lang=js"
export * from "./ServiceProviderConfigurationHeader.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderConfigurationHeader.vue?vue&type=style&index=0&id=e1023e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1023e64",
  null
  
)

export default component.exports